import type { MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode as DemandSearchTrendsKeywords } from "@similarweb/pro-api-client";

/**
 * The Table component in Pro Logic Components uses the `dataIndex` property to retrieve cell data from a row and as a sorting key.
 * If the user exports data to Excel, we use this sorting key in the `sort` query parameter. Therefore, we must use the same names as the backend.
 * Check out the table endpoints implementation to see what names are used.
 */
interface KeywordsBreakdownSortableFields {
    SearchTerm: string;
    VolumeShare: number;
    TotalVolumeChange?: number;
    MonthlyVolume: number;
}

export interface KeywordsBreakdownTableRow extends KeywordsBreakdownSortableFields {
    id: string;
    PrevMonthlyVolume?: number;
    PrevVolumeShare?: number;
    CompareVolumeChange?: number;
}

export type KeywordsBreakdownSortState = {
    columnKey: string;
    order: "ascend" | "descend";
};

export const processKeywordsBreakdownData = (
    result: DemandSearchTrendsKeywords,
): KeywordsBreakdownTableRow[] => {
    if (!result.children) {
        return [];
    }

    return result.children.map((child) => {
        if (child.previousPeriod !== undefined) {
            return {
                id: child.name,
                SearchTerm: child.name,
                VolumeShare: child.currentPeriod.volumeShare,
                TotalVolumeChange: child.currentPeriod.periodVolumeChange?.change,
                MonthlyVolume: child.currentPeriod.averageVolume,
                PrevMonthlyVolume: child.previousPeriod.averageVolume,
                PrevVolumeShare: child.previousPeriod.volumeShare,
                CompareVolumeChange: child.currentPeriod.periodVolumeChange?.change,
            };
        }

        return {
            id: child.name,
            SearchTerm: child.name,
            VolumeShare: child.currentPeriod.volumeShare,
            TotalVolumeChange: child.currentPeriod.periodVolumeChange?.change,
            MonthlyVolume: child.currentPeriod.averageVolume,
        };
    });
};
